import { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";

export default function PageAPI({
  page = 0,               // página atual da API
  size = 20,              // tamanho atual da página
  totalElements = 0,      // total da API
  totalPages = 0,         // total de páginas da API
  loading = false,
  onPageChange,
  onPageSizeChange,
  children,
  pageSizeOptions = [20, 50, 100, 1000, 2000],
}) {

  const handleGoToPage = (newPage) => {
    if (newPage < 0 || newPage >= totalPages) return;
    onPageChange && onPageChange(newPage);
  };

  const handlePageSize = (newSize) => {
    onPageSizeChange && onPageSizeChange(newSize);
    onPageChange && onPageChange(0); // sempre reseta para página 0
  };

  const startIndex = totalElements === 0 ? 0 : page * size + 1;
  const endIndex = Math.min((page + 1) * size, totalElements);

  return (
    <div className="mt-4">
      <div className="px-1 flex flex-wrap justify-between items-center gap-3 mt-4">

        {/* Texto "Mostrando X-Y de Z" */}
        <div className="text-sm text-muted-foreground">
          {loading ? (
            <div className="animate-pulse space-y-4">
              <div className="h-4 bg-muted rounded w-24"></div>
            </div>
          ) : (
            <span>
              Mostrando <strong className="text-foreground font-medium">{startIndex}-{endIndex}</strong> de{" "}
              <strong className="text-foreground font-medium">{totalElements}</strong> registros
            </span>
          )}
        </div>

        {/* Dropdown pageSize */}
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-2">
            <Dropdown
              options={pageSizeOptions}
              value={size}
              onChange={(e) => handlePageSize(e.target.value)}
              className="h-9 items-center"
            />
          </div>

          {/* Navegação */}
          <div className="flex items-center gap-1">
            <button
              onClick={() => handleGoToPage(0)}
              disabled={page === 0}
              className="w-8 h-8 flex items-center justify-center border border-input rounded-md text-sm text-muted-foreground disabled:opacity-40 hover:bg-muted hover:text-foreground transition-colors"
            >
              «
            </button>
            <button
              onClick={() => handleGoToPage(page - 1)}
              disabled={page === 0}
              className="w-8 h-8 flex items-center justify-center border border-input rounded-md text-sm text-muted-foreground disabled:opacity-40 hover:bg-muted hover:text-foreground transition-colors"
            >
              ‹
            </button>

            <span className="min-w-8 h-8 px-2 flex items-center justify-center bg-primary text-primary-foreground text-sm font-medium rounded-md">
              {page + 1}
            </span>

            <button
              onClick={() => handleGoToPage(page + 1)}
              disabled={page >= totalPages - 1}
              className="w-8 h-8 flex items-center justify-center border border-input rounded-md text-sm text-muted-foreground disabled:opacity-40 hover:bg-muted hover:text-foreground transition-colors"
            >
              ›
            </button>
            <button
              onClick={() => handleGoToPage(totalPages - 1)}
              disabled={page >= totalPages - 1}
              className="w-8 h-8 flex items-center justify-center border border-input rounded-md text-sm text-muted-foreground disabled:opacity-40 hover:bg-muted hover:text-foreground transition-colors"
            >
              »
            </button>
          </div>
        </div>

        {children && (
          <div className="col-12 col-md-9 text-sm text-muted-foreground p-0">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
